import Vue from 'vue';
import Router from 'vue-router';
import Deliveries from './views/Deliveries.vue';
import Models from './views/Models.vue';
import Sources from './views/Sources.vue';
import PointsApi from './views/PointsApi.vue';
import PointsViewer from './views/PointsViewer.vue';
import Settings from './views/Settings.vue';


Vue.use(Router);

export default new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/about',
            name: 'about',
            // route level code-splitting
            // this generates a separate chunk (about.[hash].js) for this route
            // which is lazy-loaded when the route is visited.
            component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
        },

        // {
        //     path: '/ui/deliveries',
        //     name: 'deliveries',
        //     component: Deliveries,
        // },

        {
            path: '/ui/models',
            name: 'models',
            component: Models,
        },

        {
            path: '/ui/sources',
            name: 'sources',
            component: Sources,
        },

        {
            path: '/ui/points',
            name: 'points',
            component: PointsApi,
        },

	{
	    path: '/ui/points/:collname',
	    name: 'pointsForColl',
	    component: PointsViewer,
	    props: true,
	},

	{
	    path: '/ui/settings',
	    name: 'settings',
	    component: Settings,
	},
    ],
});
